import { render } from "./AccountSetting.vue?vue&type=template&id=3bff5f65&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"

import "./AccountSetting.vue?vue&type=style&index=0&id=3bff5f65&lang=less&scoped=true"
import "./AccountSetting.vue?vue&type=style&index=1&id=3bff5f65&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bff5f65"]])

export default __exports__